import { downloadFile, IFileReturn } from "../downloadFile";

/**
 * Download origin traffic light statistics as JSON.
 *
 * @param backEndUrl - Base backend URL
 * @returns Axios-like result object
 */
export const downloadStats = async (backEndUrl: string): Promise<IFileReturn> => {
  const fileName = "OriginTrafficLight.json";
  const response = await downloadFile({
    url: `${backEndUrl}Hierarchy/StatsReport`,
    fileName,
    fileType: "application/json",
    blob: true,
    successMessage: "File successfully downloaded",
    errorMessage: "An error has occurred downloading the file",
    controller: new AbortController(),
  });
  return response;
};
